<template>
    <b-field>
        <b-select
            v-model="answer"
            placeholder="Select an answer"
            required
            expanded
            size="is-medium"
            @input="onInput"
        >
            <option
                v-for="option in question.answers"
                :key="option.strItem"
                :value="option.strItem"
            >
                {{ option.strItem }}
            </option>
        </b-select>
    </b-field>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            answer: '',
        };
    },

    methods: {
        onInput() {
            // emit event to update parent data
            this.$emit('input', this.answer);
        },
    },
};
</script>